import { PRICE_SELECTED } from "pu-data/QuoteSteps";

export const buildAssemblyData = (arg) => {
  const { quoteStep, assemblyVariant, parameters, zip_file_input_id, project_number, project_reference } = arg;
  if (quoteStep !== PRICE_SELECTED) return null;

  let form = new FormData();
  form.append('parameters[project_number]', project_number);
  form.append('parameters[project_reference]', project_reference);
  form.append('variant_id', assemblyVariant);
  Object.keys(parameters).forEach((key) => {
    form.append(`parameters[${key}]`, parameters[key]);
  });
  
  const input_file = $(`#${zip_file_input_id}`)
  const file = input_file ? input_file.prop("files")[0] : null
  if(file) form.append('parameters[filename]', file);

  return form;
}

export const buildForms = (args) => {
  if(!args) return [];
  const assemblyForm = buildAssemblyData(args);
  return assemblyForm ? [assemblyForm] : [];
}